// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agent-group .group-btn {
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-size: 12px;
}

.agent-group .create-btn {
  background-color: #3380f1;
  color: #ffffff;
}

.agent-group .disabled-btn {
  color: #afafaf;
  background-color: #e8e8e8;
}

.reassign-btn {
  color: blue;
  font-weight: 500;
  background-color: transparent;
  border: none;
  /* background-color: #016aa7;
  color: #ffffff;
  padding: 5px 10px; */
  /* border-radius: 8px; */
}

.agent-assignment .tab-view .content {
  padding-inline: 5px;
  background-color: #ffffff;
}

.agent-assignment .custom-select {
  width: 120px;
}

.wallet-link-btn {
  background-color: transparent;
  border: none;
  color: blue;
  font-size: 12px;
}

.profiled-user .user-data {
  background-color: #cecece31;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 10px;
}

.profiled-user .section-header {
  color: #7e7e7e;
  font-weight: 600;
  text-transform: uppercase;
}

.profiled-user h4 {
  text-align: left;
  letter-spacing: 0px;
  color: #7e7e7e;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 100;
  margin-top: 10px;
  margin-bottom: 5px;
}

.profiled-user .data-info {
  margin-bottom: 10px;
  color: #002277;
  font-size: 12px;
  font-weight: 500;
}

.profiled-user .data-info-error {
  color: #e61515;
}

.profiled-user .uploaded-document img {
  height: 250px;
  width: 100%;
}

.profiled-user .back-btn {
  border: none;
  background-color: transparent;
  padding-bottom: 10px;
  color: #0981fd;
}

.profiled-user .back-btn i {
  color: #0981fd;
  font-size: 16px;
}

.filter-data {
  display: flex;
  margin-bottom: 15px;
  gap: 15px;
}

.filter-data .limit-select {
  width: 100px;
}

.filter-data .grouped-input {
  background-color: #ffffff;
  border: 1px solid #d2d2d2;
}

.filter-data .btn-filter {
  background-color: transparent;
  color: #060d27;
  border: 1px solid #060d27;
  height: 44px;
  padding-inline: 20px;
}

.filter-data .btn-filter:hover {
  color: #002277;
}

.filter-data .downloads img {
  height: 40px;
}

.filter-data .custom-select {
  width: 100% !important;
}

.agent-group .upgrade-btn {
  border: none;
  background-color: #262693;
  border-radius: 4px;
  margin-top: 14px;
  width: 100%;
  padding: 8px;
  color: #ffffff;
}

.agent-group .current-type {
  color: #262693;
  text-transform: capitalize;
}

.agent-group .update-modal-btn {
  border: none;
  background-color: #e3be42;
  border-radius: 4px;
  padding: 5px;
  color: #ffffff;
}

.agent-group .merchant-list .modal-content {
  width: 80%;
  text-align: left;
  height: 90%;
  overflow: scroll;
}

.agent-group .request-onboard-modal {
  padding: 0;
  text-align: left;
}

.agent-group .request-onboard-modal p {
  margin-bottom: 0;
}

.agent-group .merchant-list .modal .close {
  top: 20px;
  right: 30px;
  background-color: black;
  color: #ffffff;
  z-index: 100;
}

.agent-group .modal .close:hover {
  background-color: grey;
}

.agent-group .modal .request-action-btn {
  border: none;
  padding: 8px;
  border-radius: 4px;
  color: #ffffff;
  margin-right: 10px;
}

.agent-group .modal .approve-merchant {
  background-color: rgb(15, 105, 46);
}

.agent-group .modal .reject-merchant {
  background-color: rgb(218, 34, 34);
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/profle/GroupProfile.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ;;sBAEoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".agent-group .group-btn {\n  border: none;\n  border-radius: 8px;\n  padding: 14px;\n  font-size: 12px;\n}\n\n.agent-group .create-btn {\n  background-color: #3380f1;\n  color: #ffffff;\n}\n\n.agent-group .disabled-btn {\n  color: #afafaf;\n  background-color: #e8e8e8;\n}\n\n.reassign-btn {\n  color: blue;\n  font-weight: 500;\n  background-color: transparent;\n  border: none;\n  /* background-color: #016aa7;\n  color: #ffffff;\n  padding: 5px 10px; */\n  /* border-radius: 8px; */\n}\n\n.agent-assignment .tab-view .content {\n  padding-inline: 5px;\n  background-color: #ffffff;\n}\n\n.agent-assignment .custom-select {\n  width: 120px;\n}\n\n.wallet-link-btn {\n  background-color: transparent;\n  border: none;\n  color: blue;\n  font-size: 12px;\n}\n\n.profiled-user .user-data {\n  background-color: #cecece31;\n  padding: 15px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.profiled-user .section-header {\n  color: #7e7e7e;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.profiled-user h4 {\n  text-align: left;\n  letter-spacing: 0px;\n  color: #7e7e7e;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 100;\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.profiled-user .data-info {\n  margin-bottom: 10px;\n  color: #002277;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.profiled-user .data-info-error {\n  color: #e61515;\n}\n\n.profiled-user .uploaded-document img {\n  height: 250px;\n  width: 100%;\n}\n\n.profiled-user .back-btn {\n  border: none;\n  background-color: transparent;\n  padding-bottom: 10px;\n  color: #0981fd;\n}\n\n.profiled-user .back-btn i {\n  color: #0981fd;\n  font-size: 16px;\n}\n\n.filter-data {\n  display: flex;\n  margin-bottom: 15px;\n  gap: 15px;\n}\n\n.filter-data .limit-select {\n  width: 100px;\n}\n\n.filter-data .grouped-input {\n  background-color: #ffffff;\n  border: 1px solid #d2d2d2;\n}\n\n.filter-data .btn-filter {\n  background-color: transparent;\n  color: #060d27;\n  border: 1px solid #060d27;\n  height: 44px;\n  padding-inline: 20px;\n}\n\n.filter-data .btn-filter:hover {\n  color: #002277;\n}\n\n.filter-data .downloads img {\n  height: 40px;\n}\n\n.filter-data .custom-select {\n  width: 100% !important;\n}\n\n.agent-group .upgrade-btn {\n  border: none;\n  background-color: #262693;\n  border-radius: 4px;\n  margin-top: 14px;\n  width: 100%;\n  padding: 8px;\n  color: #ffffff;\n}\n\n.agent-group .current-type {\n  color: #262693;\n  text-transform: capitalize;\n}\n\n.agent-group .update-modal-btn {\n  border: none;\n  background-color: #e3be42;\n  border-radius: 4px;\n  padding: 5px;\n  color: #ffffff;\n}\n\n.agent-group .merchant-list .modal-content {\n  width: 80%;\n  text-align: left;\n  height: 90%;\n  overflow: scroll;\n}\n\n.agent-group .request-onboard-modal {\n  padding: 0;\n  text-align: left;\n}\n\n.agent-group .request-onboard-modal p {\n  margin-bottom: 0;\n}\n\n.agent-group .merchant-list .modal .close {\n  top: 20px;\n  right: 30px;\n  background-color: black;\n  color: #ffffff;\n  z-index: 100;\n}\n\n.agent-group .modal .close:hover {\n  background-color: grey;\n}\n\n.agent-group .modal .request-action-btn {\n  border: none;\n  padding: 8px;\n  border-radius: 4px;\n  color: #ffffff;\n  margin-right: 10px;\n}\n\n.agent-group .modal .approve-merchant {\n  background-color: rgb(15, 105, 46);\n}\n\n.agent-group .modal .reject-merchant {\n  background-color: rgb(218, 34, 34);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
